
import { AMORTIZATION, LOANS } from '../../../common/domain/constants.loans.js';
class LoansRepaymentSimulateController {

  constructor(EventEmitter, $scope, $state, $window) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.scope = $scope;
    this.state = $state;
    this.window = $window;
  }

  $onInit() {
    this.scope.$watch(() => this.loansSimulation, () => { });
  }

  checkSimulationIsOkey(loanSimulation) {
    if (loanSimulation === undefined) return;
    return loanSimulation.status.code === LOANS.STATUS.OK;
  }

  createParcial(loanSimulation) {
    const feePeriod = this.isFee(loanSimulation) ? AMORTIZATION.FEE : AMORTIZATION.PERIOD;
    this.repaymentParcial(this.EventEmitter({
      feePeriod
    }));
  }

  getTitle(loanSimulation) {
    if (this.isFee(loanSimulation)) {
      return 'LOANS.REPAYMENT.SIMULATE.TITLE_FEE';
    }

    if (this.isPeriod(loanSimulation)) {
      return 'LOANS.REPAYMENT.SIMULATE.TITLE_PERIOD';
    }
  }

  isFee(loanSimulation) {
    return loanSimulation.newFee != null && loanSimulation.currentFee != null;
  }

  isPeriod(loanSimulation) {
    return !!loanSimulation.currentDateExpired && !!loanSimulation.newDateExpired;
  }

  getClasses() {
    return {
      responsiveMobile: this.window.innerWidth < 1024,
      'with-floating-action-buttons': this.window.innerWidth < 1024,
      'simulate-padding': this.window.innerWidth < 1024,
    };
  }

  showCard(loanSimulation) {
    return (loanSimulation.loanId === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || loanSimulation.loanId === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN) || !!loanSimulation.currentDateExpired;
  }

  formatBackendDateToDisplay(dateString) {
    if (!dateString) return '';

    const parts = String(dateString).trim().split('-');
    if (parts.length !== 3) return String(dateString);

    const [year, month, day] = parts;

    if (year.length !== 4 || month.length !== 2 || day.length !== 2) return String(dateString);

    return `${day}-${month}-${year}`;
  }
}

export default LoansRepaymentSimulateController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentSimulate/loansRepaymentSimulate.controller.js